(function(w,d,c) {
	var s=d.createElement('script'),
		h=d.getElementsByTagName('script')[0];
	s.type='text/javascript';
	s.async=true;s.charset='utf-8';
	s.src=(d.location.protocol==='https:'?'https:':'http:')+'//site.yandex.net/v2.0/js/all.js';
	h.parentNode.insertBefore(s,h);
	(w[c]||(w[c]=[])).push(function(){
		Ya.Site.Results.init();
	})
})(window,document,'yandex_site_callbacks')


